<template>
  <v-main>
    <header-components></header-components>
    <title-components></title-components>
    <v-container
      class="mx-auto mt-6"
      style="max-width: 1200px;"
    >
      <progress-components page="medical"></progress-components>
      <v-form ref="form" class="mt-12">
        <v-card
          class="mx-auto mt-6"
          elevation="1"
          outlined
        >
          <v-card-title>
            <strong>検査_検体採取日 </strong><span class="text-red"><strong> *</strong></span>
          </v-card-title>
          <v-responsive
            class="mx-5"
            max-width="344"
          >
            <div class="mb-5">※検査を実施した日をご記入ください。</div>
            <v-text-field
              v-model="inspectionDate"
              variant="underlined"
              type="date"
              :rules="[dateValidate(inspectionDate)]"
            ></v-text-field>
          </v-responsive>
        </v-card>
        <v-card
          class="mx-auto mt-6"
          elevation="1"
          outlined
        >
          <v-card-title>
            <strong>新型コロナウイルスワクチン_接種歴 </strong><span class="text-red"><strong> *</strong></span>
          </v-card-title>
          <v-responsive
            class="mx-5"
            max-width="344"
          >
            <v-select
              label="選択してください"
              :items="selectInoculationHistories"
              :rules="[required]"
              variant="underlined"
              v-model="vaccinationHistory"
            ></v-select>
          </v-responsive>
        </v-card>
        <div v-show="hasVaccinationHistory">
          <v-card
            class="mx-auto mt-6"
            elevation="1"
            outlined
          >
            <v-card-title>
              <strong>新型コロナウイルスワクチン_直近接種年月日 </strong><span class="text-red"><strong> *</strong></span>
            </v-card-title>
            <v-responsive
              class="mx-5"
              max-width="344"
            >
              <v-text-field
                v-model="coronaVaccinationDate"
                variant="underlined"
                type="date"
                :rules="[dateValidateIfNeeded(coronaVaccinationDate, hasVaccinationHistory)]"
              ></v-text-field>
            </v-responsive>
          </v-card>
          <v-card
            class="mx-auto mt-6"
            elevation="1"
            outlined
          >
            <v-card-title>
              <strong>新型コロナウイルスワクチン_直近接種 </strong><span class="text-red"><strong> *</strong></span>
            </v-card-title>
            <v-responsive
              class="mx-5"
              max-width="344"
            >
              <v-select
                label="選択してください"
                :items="selectVaccines"
                :rules="[requiredIfNeeded(hasVaccinationHistory)]"
                variant="underlined"
                v-model="coronaVaccineName"
              ></v-select>
            </v-responsive>
          </v-card>
        </div>
        <v-card
          class="mx-auto mt-6"
          elevation="1"
          outlined
        >
          <v-card-title>
            <strong>インフルエンザワクチン_1年以内の接種歴 </strong><span class="text-red"><strong> *</strong></span>
          </v-card-title>
          <v-radio-group
            v-model="fluVaccinationHistory"
            class="mx-2 mb-4"
            :rules="[required]"
          >
            <v-radio class="mt-2" v-for="item in selectFlagIndicators" :key="item" :label="item" :value="item" color="doorMainColor"></v-radio>
          </v-radio-group>
        </v-card>
        <v-card
          class="mx-auto mt-6"
          elevation="1"
          outlined
        >
          <v-card-title>
            <strong>症状の有無 </strong><span class="text-red"><strong> *</strong></span>
          </v-card-title>
          <v-radio-group
            v-model="symptoms"
            class="mx-2 mb-4"
            :rules="[required]"
          >
            <v-radio class="mt-2" v-for="item in selectFlagIndicators" :key="item" :label="item" :value="item" color="doorMainColor"></v-radio>
          </v-radio-group>
        </v-card>
        <div v-show="isSymptoms">
          <v-card
            class="mx-auto mt-6"
            elevation="1"
            outlined
          >
            <v-card-title>
              <strong>症状が発生した日 </strong><span class="text-red"><strong> *</strong></span>
            </v-card-title>
            <v-responsive
              class="mx-5"
              max-width="344"
            >
              <v-text-field
                v-model="dateOfOnset"
                variant="underlined"
                type="date"
                :rules="[dateValidateIfNeeded(dateOfOnset, isSymptoms), requiredIfNeeded(isSymptoms)]"
              ></v-text-field>
            </v-responsive>
          </v-card>
          <v-card
            class="mx-auto mt-6"
            elevation="1"
            outlined
          >
            <v-card-title>
              <strong>症状_発熱 </strong><span class="text-red"><strong> *</strong></span>
            </v-card-title>
            <v-radio-group
              v-model="fever"
              class="mx-2 mb-4"
              :rules="[requiredIfNeeded(isSymptoms)]"
            >
              <v-radio class="mt-2" v-for="item in selectFever" :key="item" :label="item" :value="item" color="doorMainColor"></v-radio>
            </v-radio-group>
          </v-card>
          <v-card
            class="mx-auto mt-6"
            elevation="1"
            outlined
            v-show="isFever"
          >
            <v-card-title>
              <strong>症状_発熱時の体温 </strong><span class="text-red"><strong> *</strong></span>
            </v-card-title>
              <v-row class="mx-5" no-gutters>
                <v-col cols="2">
                  <v-text-field
                    variant="underlined"
                    :rules="[requiredIfNeeded(isFever && isSymptoms), feverNumber(isFever && isSymptoms, feverNum)]"
                    v-model="feverNum"
                    type="number"
                  ></v-text-field>
                </v-col>
                <v-col cols="1" class="text-transform mt-6 mr-10">度</v-col>
              </v-row>
          </v-card>
          <v-card
            class="mx-auto mt-6"
            elevation="1"
            outlined
          >
            <v-card-title>
              <strong>症状_せき</strong><span class="text-red"><strong> *</strong></span>
            </v-card-title>
            <v-radio-group
              v-model="cough"
              class="mx-2 mb-4"
              :rules="[requiredIfNeeded(isSymptoms)]"
            >
              <v-radio class="mt-2" v-for="item in selectFlagIndicators" :key="item" :label="item" :value="item" color="doorMainColor"></v-radio>
            </v-radio-group>
          </v-card>
          <v-card
            class="mx-auto mt-6"
            elevation="1"
            outlined
          >
            <v-card-title>
              <strong>症状_せき以外の呼吸器症状</strong><span class="text-red"><strong> *</strong></span>
            </v-card-title>
            <v-radio-group
              v-model="otherThanCough"
              class="mx-2 mb-4"
              :rules="[requiredIfNeeded(isSymptoms)]"
            >
              <v-radio class="mt-2" v-for="item in selectFlagIndicators" :key="item" :label="item" :value="item" color="doorMainColor"></v-radio>
            </v-radio-group>
          </v-card>
          <v-card
            class="mx-auto mt-6"
            elevation="1"
            outlined
          >
            <v-card-title>
              <strong>症状_倦怠感</strong><span class="text-red"><strong> *</strong></span>
            </v-card-title>
            <v-radio-group
              v-model="senseOfFatigue"
              class="mx-2 mb-4"
              :rules="[requiredIfNeeded(isSymptoms)]"
            >
              <v-radio class="mt-2" v-for="item in selectFlagIndicators" :key="item" :label="item" :value="item" color="doorMainColor"></v-radio>
            </v-radio-group>
          </v-card>
          <v-card
            class="mx-auto mt-6"
            elevation="1"
            outlined
          >
            <v-card-title>
              <strong>症状_頭痛</strong><span class="text-red"><strong> *</strong></span>
            </v-card-title>
            <v-radio-group
              v-model="headache"
              class="mx-2 mb-4"
              :rules="[requiredIfNeeded(isSymptoms)]"
            >
              <v-radio class="mt-2" v-for="item in selectFlagIndicators" :key="item" :label="item" :value="item" color="doorMainColor"></v-radio>
            </v-radio-group>
          </v-card>
          <v-card
            class="mx-auto mt-6"
            elevation="1"
            outlined
          >
            <v-card-title>
              <strong>症状_嘔気/嘔吐</strong><span class="text-red"><strong> *</strong></span>
            </v-card-title>
            <v-radio-group
              v-model="nausea"
              class="mx-2 mb-4"
              :rules="[requiredIfNeeded(isSymptoms)]"
            >
              <v-radio class="mt-2" v-for="item in selectFlagIndicators" :key="item" :label="item" :value="item" color="doorMainColor"></v-radio>
            </v-radio-group>
          </v-card>
          <v-card
            class="mx-auto mt-6"
            elevation="1"
            outlined
          >
            <v-card-title>
              <strong>症状_下痢</strong><span class="text-red"><strong> *</strong></span>
            </v-card-title>
            <v-radio-group
              v-model="diarrhea"
              class="mx-2 mb-4"
              :rules="[requiredIfNeeded(isSymptoms)]"
            >
              <v-radio class="mt-2" v-for="item in selectFlagIndicators" :key="item" :label="item" :value="item" color="doorMainColor"></v-radio>
            </v-radio-group>
          </v-card>
          <v-card
            class="mx-auto mt-6"
            elevation="1"
            outlined
          >
            <v-card-title>
              <strong>症状_結膜炎</strong><span class="text-red"><strong> *</strong></span>
            </v-card-title>
            <v-radio-group
              v-model="conjunctivitis"
              class="mx-2 mb-4"
              :rules="[requiredIfNeeded(isSymptoms)]"
            >
              <v-radio class="mt-2" v-for="item in selectFlagIndicators" :key="item" :label="item" :value="item" color="doorMainColor"></v-radio>
            </v-radio-group>
          </v-card>
          <v-card
            class="mx-auto mt-6"
            elevation="1"
            outlined
          >
            <v-card-title>
              <strong>症状_咽頭痛</strong><span class="text-red"><strong> *</strong></span>
            </v-card-title>
            <v-radio-group
              v-model="pharyngitis"
              class="mx-2 mb-4"
              :rules="[requiredIfNeeded(isSymptoms)]"
            >
              <v-radio class="mt-2" v-for="item in selectFlagIndicators" :key="item" :label="item" :value="item" color="doorMainColor"></v-radio>
            </v-radio-group>
          </v-card>
        </div>
      </v-form>
    </v-container>
    <v-container style="margin-top: 0;">
     <v-row v-if="fromConfirm" justify="center" align-content="center" class="mb-6 btn-area">
        <v-btn
          dark
          color="doorAccentColor"
          x-large min-width="362px" class="mb-4 mx-4"
          @click="clickedNext"
        >確認
        </v-btn>
      </v-row>
      <v-row v-else justify="center" align-content="center" class="mb-6 btn-area">
        <v-btn
          dark
          color="#B0B6BA"
          x-large min-width="362px" class="mb-4 mx-4"
          @click="toBack"
        >戻る
        </v-btn>
        <v-btn
          dark
          x-large min-width="362px"
          color="doorAccentColor"
          class="mb-4 mx-4 white--text"
          @click="clickedNext"
        >次へ
        </v-btn>
      </v-row>
    </v-container>
    <footer-components></footer-components>
  </v-main>
</template>

<script>
import { defineComponent, ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { Logger } from 'aws-amplify'
import { useRouter } from 'vue-router'
import { useFormValidator } from '@/func/useFormValidator'
import { useMedicalValues } from '@/const/form/useMedicalValues'
import { useCrossSectional } from '@/const/form/useCrossSectional'
import { useScreenOperation } from '@/func/useScreenOperation'
import HeaderComponents from '@/components/InterviewHeader.vue'
import FooterComponents from '@/components/InterviewFooter.vue'
import TitleComponents from '@/components/InterviewTitle.vue'
import ProgressComponents from '@/components/InterviewProgress.vue'

const logger = new Logger('AdvanceFormMedical');

export default defineComponent({
  components: {
    'header-components': HeaderComponents,
    'footer-components': FooterComponents,
    'title-components': TitleComponents,
    'progress-components': ProgressComponents
  },
  setup() {
    logger.info('AdvanceFormMedical')
    const form = ref(null)
    const { required, requiredOtherText, requiredIfNeeded, feverNumber, dateValidate, dateValidateIfNeeded } = useFormValidator()
    const { selectSearchMethods, selectInoculationHistories, selectVaccines, selectFever } = useMedicalValues()
    const { selectFlagIndicators } = useCrossSectional()
    const { scrollToErrorPosition, scrollToTop, fromConfirmScreen, toErrorIfNotExistsId } = useScreenOperation()

    onMounted(() => {
      scrollToTop()
      toErrorIfNotExistsId()
    })

    const fromConfirm = computed(() => fromConfirmScreen())
    const store = useStore()
    const inspectionDate = computed({
      get: () => store.state.advanceInterview.inspectionDate,
      set: (value) => store.dispatch('advanceInterview/setInspectionDate', value)
    })
    const kitName = computed({
      get: () => store.state.advanceInterview.kitName,
      set: (value) => store.dispatch('advanceInterview/setKitName', value)
    })
    const searchMethod = computed({
      get: () => store.state.advanceInterview.searchMethod,
      set: (value) => store.dispatch('advanceInterview/setSearchMethod', value)
    })
    const searchOtherMethod = computed({
      get: () => store.state.advanceInterview.searchOtherMethod,
      set: (value) => store.dispatch('advanceInterview/setSearchOtherMethod', value)
    })
    const vaccinationHistory = computed({
      get: () => store.state.advanceInterview.vaccinationHistory,
      set: (value) => store.dispatch('advanceInterview/setVaccinationHistory', value)
    })
    const coronaVaccinationDate = computed({
      get: () => store.state.advanceInterview.coronaVaccinationDate,
      set: (value) => store.dispatch('advanceInterview/setCoronaVaccinationDate', value)
    })
    const coronaVaccineName = computed({
      get: () => store.state.advanceInterview.coronaVaccineName,
      set: (value) => store.dispatch('advanceInterview/setCoronaVaccineName', value)
    })
    const fluVaccinationHistory = computed({
      get: () => store.state.advanceInterview.fluVaccinationHistory,
      set: (value) => store.dispatch('advanceInterview/setFluVaccinationHistory', value)
    })
    const symptoms = computed({
      get: () => store.state.advanceInterview.symptoms,
      set: (value) => store.dispatch('advanceInterview/setSymptoms', value)
    })
    const dateOfOnset = computed({
      get: () => store.state.advanceInterview.dateOfOnset,
      set: (value) => store.dispatch('advanceInterview/setDateOfOnset', value)
    })
    const fever = computed({
      get: () => store.state.advanceInterview.fever,
      set: (value) => store.dispatch('advanceInterview/setFever', value)
    })
    const feverNum = computed({
      get: () => store.state.advanceInterview.feverNum,
      set: (value) => store.dispatch('advanceInterview/setFeverNum', value)
    })
    const cough = computed({
      get: () => store.state.advanceInterview.cough,
      set: (value) => store.dispatch('advanceInterview/setCough', value)
    })
    const otherThanCough = computed({
      get: () => store.state.advanceInterview.otherThanCough,
      set: (value) => store.dispatch('advanceInterview/setOtherThanCough', value)
    })
    const headache = computed({
      get: () => store.state.advanceInterview.headache,
      set: (value) => store.dispatch('advanceInterview/setHeadache', value)
    })
    const senseOfFatigue = computed({
      get: () => store.state.advanceInterview.senseOfFatigue,
      set: (value) => store.dispatch('advanceInterview/setSenseOfFatigue', value)
    })
    const nausea = computed({
      get: () => store.state.advanceInterview.nausea,
      set: (value) => store.dispatch('advanceInterview/setNausea', value)
    })
    const diarrhea = computed({
      get: () => store.state.advanceInterview.diarrhea,
      set: (value) => store.dispatch('advanceInterview/setDiarrhea', value)
    })
    const conjunctivitis = computed({
      get: () => store.state.advanceInterview.conjunctivitis,
      set: (value) => store.dispatch('advanceInterview/setConjunctivitis', value)
    })
    const pharyngitis = computed({
      get: () => store.state.advanceInterview.pharyngitis,
      set: (value) => store.dispatch('advanceInterview/setPharyngitis', value)
    })
    const isSymptoms = computed(() => symptoms.value == '有')
    const hasVaccinationHistory = computed(() => vaccinationHistory.value !=='0回' && vaccinationHistory.value !== '不明' && vaccinationHistory.value !== '')

    const isFever = computed(() => fever.value === '37.5度以上')
    const router = useRouter()
    const toBack = () => router.go(-1)
    const clickedNext = async () => {
      const result = await form.value.validate()
      if (!result.valid) {
         scrollToErrorPosition()
         return
      }
      if (fromConfirm.value) {
        router.push('/interview/confirm')
      } else {
        router.push('/interview/contact')
      }
    }

    return {
      form,
      toBack,
      selectSearchMethods,
      selectInoculationHistories,
      selectVaccines,
      selectFlagIndicators,
      selectFever,
      required,
      requiredOtherText,
      requiredIfNeeded,
      inspectionDate,
      kitName,
      searchMethod,
      searchOtherMethod,
      vaccinationHistory,
      coronaVaccinationDate,
      coronaVaccineName,
      fluVaccinationHistory,
      symptoms,
      dateOfOnset,
      senseOfFatigue,
      fever,
      cough,
      otherThanCough,
      headache,
      nausea,
      diarrhea,
      conjunctivitis,
      pharyngitis,
      isSymptoms,
      hasVaccinationHistory,
      clickedNext,
      fromConfirm,
      isFever,
      feverNum,
      feverNumber,
      dateValidate,
      dateValidateIfNeeded,
    }
  }
})

</script>

<style scoped>
.v-input :deep(.v-label) {
  color: rgba(0, 0, 0, .87) !important;
}
.v-card-title {
  white-space: inherit !important;
}

@media screen and (max-width: 960px) {
  .btn-area button{
    min-width: 55%!important;
  }
}

</style>
